import { createRouter, createWebHistory } from 'vue-router';
import { LoginCallback } from '@okta/okta-vue';
import { oktaAuth } from '@/auth';
import { devAuthActive } from '@/apps/course-content-review/config';
import { videoRoutes } from '@/apps/video/routes';
import { dashboardRoutes } from '@/apps/dashboard/routes';
import { imageRoutes } from '@/apps/image/routes';
import { questionRoutes } from '@/apps/text/routes';
import { courseContentReviewRoutes } from '@/apps/course-content-review/routes';
import {
  appRoutesDefinitions,
  videoRoutesDefinitions,
  dashboardRoutesDefinitions,
  imageRoutesDefinitions,
  textRoutesDefinitions,
  courseContentReviewRoutesDefinitions
} from '@/routes-definitions';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Login
    {
      path: `/${appRoutesDefinitions.login.path}`,
      name: appRoutesDefinitions.login.name,
      component: () => import('@/apps/login/LoginApp.vue')
    },
    {
      path: `/${appRoutesDefinitions.loginCallback.path}`,
      name: appRoutesDefinitions.loginCallback.name,
      component: LoginCallback
    },
    // Dashboard app
    {
      path: '/',
      redirect: { name: dashboardRoutesDefinitions.home.name }
    },
    {
      path: `/${appRoutesDefinitions.dashboard.path}`,
      name: appRoutesDefinitions.dashboard.name,
      component: () => import('@/apps/dashboard/DashboardApp.vue'),
      redirect: { name: dashboardRoutesDefinitions.home.name },
      children: dashboardRoutes
    },
    // Video app
    {
      path: `/${appRoutesDefinitions.video.path}`,
      name: appRoutesDefinitions.video.name,
      component: () => import('@/apps/video/VideoApp.vue'),
      redirect: { name: videoRoutesDefinitions.homeV2.name },
      children: videoRoutes
    },
    // Text app
    {
      path: `/${appRoutesDefinitions.text.path}`,
      name: appRoutesDefinitions.text.name,
      component: () => import('@/apps/text/TextApp.vue'),
      redirect: { name: textRoutesDefinitions.kfkV2.name },
      children: questionRoutes
    },
    // Course Content Review app
    {
      path: `/${appRoutesDefinitions.courseContentReview.path}`,
      name: appRoutesDefinitions.courseContentReview.name,
      component: () => import('@/apps/course-content-review/CourseContentReviewApp.vue'),
      redirect: { name: courseContentReviewRoutesDefinitions.contentReview.name },
      children: courseContentReviewRoutes
    },
    // Image app
    {
      path: `/${appRoutesDefinitions.image.path}`,
      name: appRoutesDefinitions.image.name,
      component: () => import('@/apps/image/ImageApp.vue'),
      redirect: { name: imageRoutesDefinitions.home.name },
      children: imageRoutes
    },
    // Default route
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: dashboardRoutesDefinitions.home.name }
    }
  ]
});

router.beforeEach(async (to) => {
  if (devAuthActive()) return; // DEV-only bypass (see config.devAuthActive): enter without Okta
  if (
    !(await oktaAuth.isAuthenticated()) &&
    to.name !== appRoutesDefinitions.loginCallback.name &&
    to.name !== appRoutesDefinitions.login.name
  ) {
    return { name: appRoutesDefinitions.login.name };
  }
});

router.beforeEach(async () => {
  const event = new CustomEvent('force-save-all');
  document.dispatchEvent(event);
  await new Promise((resolve) => setTimeout(resolve, 50));
});

export default router;
